import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

const TechStack = () => {
  const { t } = useI18n();
  return (
    <section className="py-20 md:py-32 bg-[#F5F7FA]">
      <div className="zdc-container">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="text-xs font-medium uppercase tracking-[0.18em] text-[#2563EB] mb-3">{t.techStack.eyebrow}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#111111]">
            {t.techStack.title}
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#6B7280]">{t.techStack.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.techStack.categories.map((cat, i) => (
            <div
              key={i}
              data-testid="tech-category"
              className="p-6 bg-white rounded-2xl border border-[#E5E7EB] card-hover hover:border-[#111111]/20 hover:shadow-[0_20px_40px_rgba(17,17,17,0.06)]"
            >
              <div className="text-xs font-medium uppercase tracking-wider text-[#6B7280] mb-4">
                {cat.name}
              </div>
              <div className="flex flex-wrap gap-1.5">
                {cat.items.map((tool, j) => (
                  <span
                    key={j}
                    className="inline-flex items-center px-3 py-1.5 rounded-full bg-[#F5F7FA] border border-[#E5E7EB] text-xs font-medium text-[#111111] hover:bg-white hover:border-[#2563EB]/40 hover:text-[#2563EB] transition-colors"
                  >
                    {tool}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
